
import TitleBox from '@/components/CSS/TitleBox'
export default {
    components: {
        TitleBox
    },
    data() {
        return {
            loading: false,
            ruleForm: {
                linkPhone: null,
                linkQq: null,
                linkWx: null
            },
            rules: {
                linkPhone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur'
                    }
                ],
                linkQq: [
                    { required: true, message: '请输入QQ号码', trigger: 'blur' },
                    {
                        pattern: /^[1-9]\d{4,10}$/,
                        message: '请输入正确的QQ号码',
                        trigger: 'blur'
                    }
                ],
                linkWx: [{ required: true, message: '请输入微信号码', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.getUserLink()
    },
    methods: {
        getUserLink() {
            this.$api.userLink().then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.ruleForm = res.data
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true
                    let p = {
                        action: this.ruleForm
                    }
                    this.$api.userLinkSave(p).then((res) => {
                        this.loading = false
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        this.$store.commit('game/SET_PAY_INFO', {})
                        this.$message.success(res.info)
                        this.$router.push('/account/bargainMe')
                    })
                }
            })
        }
    }
}
